import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { PageHeader } from "antd";

import { getUrl, requests } from "../../globals/requests";
import {
  Container,
  SpaceBetween,
  CenterHorizontal,
} from "../../globals/styles";
import { Input, Button } from "../../components";
import { helpers } from "../../utils";
import "./styles.css";

function AddNewOrganization() {
  const [organisation, setOrganisation] = useState({
    name: "",
    street_address: "",
    state: "",
    country: "",
  });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  function handleInputChange(e) {
    const { name, value } = e.target;
    setOrganisation({ ...organisation, [name]: value });
  }

  async function handleAddNewOrganisation() {
    try {
      const url = `${getUrl("organisations")}/create`;
      setLoading(true);

      const data = { ...organisation };
      await requests.postWithAuth(url, data);
      setLoading(false);
      helpers.successModal("Organisation added!!!");
    } catch (e) {
      setLoading(false);
      helpers.displayMessage(e);
    }

    history.goBack();
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Add organisation"
        subTitle="Organisation"
      />
      <SpaceBetween>
        <div>
          <p>
            <b>Name</b>
          </p>
          <Input
            name="name"
            onChange={handleInputChange}
            value={organisation.name}
          />
        </div>
        <div>
          <p className="edctrct-align-right">
            <b>Street address</b>
          </p>
          <Input
            name="street_address"
            onChange={handleInputChange}
            value={organisation.street_address}
          />
        </div>
      </SpaceBetween>
      <SpaceBetween>
        <div>
          <p>
            <b>State</b>
          </p>
          <Input
            name="state"
            onChange={handleInputChange}
            value={organisation.state}
          />
        </div>
        <div>
          <p className="edctrct-align-right">
            <b>Country</b>
          </p>
          <Input
            name="country"
            onChange={handleInputChange}
            value={organisation.country}
          />
        </div>
      </SpaceBetween>

      <CenterHorizontal>
        <Button
          onClick={handleAddNewOrganisation}
          loading={loading}
          title="Add"
          type="primary"
        />
      </CenterHorizontal>
    </Container>
  );
}

export default AddNewOrganization;
